export class MultiPurposeBalanceCompensationModel {
  Id: number;
  EarningPercentage: number;
  BaseCalculationMethodId: number;
  PensionSharePercentage: number;
  BalanceDefinitionId: number;
  UserEmploymentId?: number;
  EmploymentTemplateId?: number;
  EarningFixedAmount?: number;
  EarningFixedAmountPrincipleId?: number;
  PensionShareFixedAmount?: number;
  DaysConversionPercentage?: number;
  DaysEarnedPerPayslip?: number;
  PayoutPercentage?: number;

  SeniorityRequirementMonths?: number;
  CustomBehaviorId?: number;

  public constructor() {
    this.BalanceDefinitionId = 3;
    this.EarningFixedAmount = null;
    this.EarningFixedAmountPrincipleId = null;
    this.PensionShareFixedAmount = null;
    this.Id = null;
    this.DaysConversionPercentage = null;
    this.DaysEarnedPerPayslip = null;
    this.PayoutPercentage = null;

    this.SeniorityRequirementMonths = null;
    this.CustomBehaviorId = null;
  }
}
